import { AxiosInstance, AxiosPromise } from 'axios';
import CRUD from '../base/crud';

export type KeyT = {
  id: number;
  userId: number;
  credentialID: number;
  publicKey: string;
  userName: string;
  createAt: string;
};

export type CreateKey = {
  data: any;
};

export class KeyCRUD extends CRUD<KeyT> {
  usersKeys(): AxiosPromise<KeyT[]> {
    return this.r({
      method: 'GET',
      url: `${this.config.url}s`,
    });
  }

  me(): AxiosPromise<KeyT[]> {
    return this.r({
      method: 'GET',
      url: `${this.config.url}/me`,
    });
  }
}

export default function keysCRUD(request: AxiosInstance): KeyCRUD {
  const crud = new KeyCRUD({
    url: '/user/key',
    request,
    id: 'id',
  });

  return crud;
}
